



























import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import LoginKey from "@/components/login-key";
import DialogLoginError from "../../../views/Auth/DialogLoginError.vue";
import router from "../../../router";
import customValidator from "@/lib/customValidator.ts";
export default createComponent({
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const login = inject(LoginKey);
    if (!login) {
      throw new Error(`${LoginKey} is not provided`);
    }

    const registForm = ref(null);

    onMounted(() => {
      displayui.closeDialogConfirmAccount();
    });

    const registerInfor = computed(() => login.registerInfor);
    const registMail = async () => {
      //@ts-ignore
      if(!registForm.value.validate()){
        return;
      }
      const register = (await login.sendRegistMail()) as any;
      if (register && register.data) {
        await displayui.openDialogLoginError();
      } else {
        router.push("/company_detail/register_complete");
      }
    };
    return {
      registerInfor,
      registMail,
      customValidator,
      registForm
    };
  },
  components: {
    DialogLoginError
  }
});
